// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = '/vote/2023project/q1/2023ydjm/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const getRules = () => {
  return http.get(`${urlPrefix}rules`);
};

const checkIsFirst = (unionid: string) => {
  return http.get(`${urlPrefix}check-first&unionid=${unionid}`);
};

const saveinfo = (data: any) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}save`, qsData);
};

const getNews = (page: any, classId: any) => {
  return http.get(`/v1/news/topicList?page=${page}&classId=${classId}`);
};

const getHighSch = (schname: any) => {
  return http.get(`${urlPrefix}get-high-sch&schname=${schname}`);
};

export { getBaseInfo, getRules, saveinfo, getNews, checkIsFirst, getHighSch };
